import useInterval from '@restart/hooks/useInterval';
import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import tzlookup from 'tz-lookup';

import Term from './Term';
import styles from './TimeClock.module.scss';

import Bar from '@/components/ui/Bar';

const cx = classNames.bind(styles);

const TimeClock = () => {
  const position = useSelector((state) => state.map.position);
  const [currentTime, setCurrentTime] = useState(new Date());

  useInterval(() => setCurrentTime(new Date()), 1000);

  // 시간 문자열에서 콜론만 깜빡이게 하는 함수
  const formatTimeWithBlinkingColon = (timeString) => {
    const [hh, mm, ss] = timeString.split(':');
    return (
      <>
        {hh}
        <span className={cx('delimiter')}>:</span>
        {mm}
        <span className={cx('delimiter')}>:</span>
        {ss}
      </>
    );
  };

  // 맵 중심 기준 시간
  const localTime = currentTime.toLocaleString('en-US', {
    timeZone: tzlookup(position.lat, position.lng),
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  // 유저 시간
  const yourTime = currentTime.toLocaleTimeString('en-US', {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  return (
    <div className={cx('container')}>
      <Term label="Local Time" value={formatTimeWithBlinkingColon(localTime)} />
      <Bar size={28} />
      <Term label="Your Time" value={formatTimeWithBlinkingColon(yourTime)} />
    </div>
  );
};

export default TimeClock;
